import { BindingEngine, customElement } from 'aurelia-framework';
import Chart from 'chart.js/auto';
import { ITrackingHourlyDTO } from 'api/swagger/ApiClient';
import { ModelBase } from 'support/base_classes/model-base';

@customElement('locations-chart-box')
export class LocationsChartBoxCustomElement extends ModelBase<ITrackingHourlyDTO[]> {
  chartPlaceholder: HTMLCanvasElement;
  chart: Chart<"line", any[], unknown> = null;

  constructor(bindingEngine: BindingEngine) {
    super(bindingEngine);
  }

  modelChanged(newValue: ITrackingHourlyDTO[]) {
    super.modelChanged(newValue);
    if (this.chart == null)
      this.createChart();
    else {
      this.chart.data.datasets[0].data.splice(0, this.chart.data.datasets[0].data.length, ...this.getData());
      this.chart.options.scales.y.max = this.getYScaleMax();
      this.chart.update();
    }
  }

  private getData(): { x: string, y: number }[] {
    return this.model ? [...this.model.map(x => ({ x: x.dateTime.split('T')[1].substring(0, 5), y: x.count }))] : [];
  }

  private getYScaleMax(): number {
    return this.model ? Math.max(Math.ceil(this.model.map(x => x.count).sort((a, b) => b - a)[0] / 10) * 10, 10) : 10;
  }

  private createChart() {
    this.chart = new Chart(this.chartPlaceholder, {
      type: 'line',
      data: {
        datasets: [{
          data: this.getData(),
          borderColor: '#99CC00',
          pointBackgroundColor: '#99CC00',
          pointBorderColor: '#99CC00'
        }]
      },
      options: {
        animation: false,
        scales: {
          y: {
            min: 0,
            max: this.getYScaleMax()
          }
        },
        responsive: false,
        plugins: {
          legend: {
            display: false
          },
          title: {
            display: false
          }
        }
      }
    });
  }
}
